/// <amd-module name="SuiteCommerce.LookBook.LookItem.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.LookItem.View", ["require", "exports", "suitecommerce_lookbook_lookitem.tpl", "ProductViews.Price.View", "ProductLine.Stock.View", "Backbone", "SuiteCommerce.LookBook.Common.Configuration", "SuiteCommerce.LookBook.Instrumentation"], function (require, exports, lookItemTpl, ProductViewsPriceView, ProductLineStockView, Backbone_1, Configuration_1, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookItemView = void 0;
    var LookItemView = /** @class */ (function (_super) {
        __extends(LookItemView, _super);
        function LookItemView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = lookItemTpl;
            _this.events = {
                'click [data-action="clickInItemOfLook"]': 'logClickOnItemOfLook',
            };
            return _this;
        }
        LookItemView.prototype.logClickOnItemOfLook = function () {
            var logUsage = Instrumentation_1.default.getLog('Click in Item of Look');
            logUsage.setParameters({
                activity: 'Click in Item of Look'
            });
            logUsage.submit();
        };
        Object.defineProperty(LookItemView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'ItemViews.Price': function () {
                        return new ProductViewsPriceView({ model: _this.model.getItem() });
                    },
                    'ItemViews.Stock': function () {
                        return new ProductLineStockView({ model: _this.model.getItem() });
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        LookItemView.prototype.getContext = function () {
            return {
                name: this.model.getName(),
                description: this.model.getDescription(),
                link: this.model.getLink(),
                imageId: this.model.getImageId(),
                image: this.model.getImage(),
                itemname: this.model.getItemName(),
                itemId: this.model.getItemId(),
                url: this.model.getItemUrl(),
                thumbnail: this.model.getItemThumbnail(),
                isEnvironmentBrowser: Configuration_1.Configuration.isEnvironmentBrowser &&
                    !Configuration_1.Configuration.isEnvironmentTouchEnabled,
            };
        };
        return LookItemView;
    }(Backbone_1.View));
    exports.LookItemView = LookItemView;
});
